import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PeriodModel } from '../models/period.model';
import { InfraService } from './infra.service';
import { PeriodPreferenceModel } from '../models/period-preference.model';
import { EndDateIsMismatchModel } from '../models/endDateIsMismatch.model';
import { SaveScheduleData } from '../models/SaveScheduleData.model';

@Injectable()
export class PeriodService {
  private configUrl: string;

  constructor(private infraService:InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint2 + 'Period';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }
  }

  public getEngagementPeriods(engagementId:number): Observable<PeriodModel[]> {
    return this.http.get<PeriodModel[]>(`${this.configUrl}/getEngagementPeriods/${engagementId}`);
  }

  public IsEndDateMismatchExist(engagementId:number): Observable<boolean> {
    return this.http.get<boolean>(`${this.configUrl}/isEndDateMismatchExist/${engagementId}`);
  } 

  public isDatacheckEndDateMismatchExist(engagementId: number): Observable<EndDateIsMismatchModel> {
    return this.http.get<EndDateIsMismatchModel>(`${this.configUrl}/isDatacheckEndDateMismatchExist/${engagementId}`);
  }
  public UpdatePeriodPreference(periodPreferenceModel:PeriodPreferenceModel) {
    return this.http.post(`${this.configUrl}/updatePeriodPreference`,periodPreferenceModel);
  }
  public IsPeriodMissing(scheduleModel: SaveScheduleData): Observable<boolean> {
    return this.http.post<boolean>(`${this.configUrl}/isPeriodMissing`, scheduleModel);
  }

}
